export enum DropOffTypeKey {
  Mailbox = 'mailbox',
  PostOffice = 'postoffice',
  Home2Home = 'home2home',
  ReusablePackage = 'reusablepackage',
  MyOwnPackage = 'myownpackage',
  ContactlessDropoff = 'contactlessdropoff',
}
